import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Container = styled.div`
  background-color: #f9fafb;
  color: black;
  padding: 6rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormBox = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 90%;
  gap: 3rem;
  @media only screen and (min-width: 867px) {
    gap: 7rem;
  }
`;

export const LeftFormBox = styled.div`
  width: 100%;
  max-width: 25rem;
`;

export const HeaderFormBox = styled.header`
  color: black;
  margin-bottom: 3.375rem;
  h2 {
    align-items: center;
    font-size: 2.25rem;
    display: flex;
    gap: 1rem;
  }
  span {
    font-size: 0.875rem;
  }
  svg {
    color: var(--second-color);
    font-size: 2.8125rem;
  }
`;

export const Form = styled.form`
  position: relative;
  input,
  textarea,
  select {
    background-color: white;
    border-radius: 10px;
    width: 100%;
    height: 2.68rem;
    border: none;
    padding-left: 1rem;
    box-sizing: border-box;
    box-shadow: 2px 2px 8px lightgray;
    color: #000;
  }

  select {
    color: #6e6e6eff;
  }

  select:focus,
  select[value]:not([value=""]) {
    color: black;
  }

  .boxInput {
    margin-bottom: 1.5rem;
  }

  .textarea {
    margin-bottom: 2rem;
    textarea {
      height: 11.8rem;
      resize: none;
      padding: 1rem;
      font-family: Arial
    }
  }

  .error {
    margin-bottom: 0%.5rem;
    color: #f00;
    position: absolute;
  }

  button {
    background-color: #00893a;
    color: var(--white-color);
    font-size: 1rem;
    font-weight: bold;
    padding: 0.56rem 2.5rem;
    border-radius: 10px;
    display: block;
    margin: 0 auto;
    @media only screen and (min-width: 797px) {
      display: inline-block;
      margin: 0;
    }
  }
`;

export const RightFormBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  max-width: 16.2rem;
  font-size: 1rem;
  padding-top: 3rem;
  color: black;
  h3 {
    margin-bottom: 1.25rem;
    text-align: center;
  }
`;

export const InfoBox = styled.div`
  border: 1px solid black;
  padding: 1.56rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: black;
  width: fit-content;
  border-radius: 10px;
  margin-top: 0.25rem;
  font-size: 0.813rem;
  p {
    display: flex;
    align-items: center;
    margin-bottom: 1.25rem;
    svg {
      margin-right: 0.313rem;
    }
  }
`;

export const NavLinkCustom = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 247px;
  height: 43px;
  margin-bottom: 1.125rem;
  background: #f59e0b;
  box-shadow: 10px 12px 14px rgba(0, 0, 0, 0.18);
  border-radius: 10px;
  color: #30211ddc;
  font-weight: bold;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  svg {
    color: var(--seventh-color);
  }
  &:hover {
    box-shadow: 12px 24px 20px rgba(0, 0, 0, 0.18);
    transform: translateY(-2px);
  }
`;

export const MapsBox = styled.div`
  margin-top: 5rem;
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 56.5;
`;


export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
  width: 1.5rem;
  height: 1.5rem;
    path, circle {
      fill: black;
      stroke: white;
      stroke-width: 1.7px; 
    }
  }
`;